import React, {Component} from "react";
import ReactSVG from 'react-svg';
import PropTypes from "prop-types";

class SportIcon extends Component {
	static defaultProps = {
		sportId : 1
	};

	static propTypes = {
		sportId : PropTypes.number.isRequired,
	};

	render() {
		try {
			return (
				<ReactSVG path={require(`./../../assets/images/sports/svg/${this.props.sportId}.svg`)}/>
			);
		}
		catch ( err ) {
			return (
				<ReactSVG path={require(`./../../assets/images/sports/svg/1.svg`)}/>
			);
		}
	}
}

export default SportIcon;


// WEBPACK FOOTER //
// ./src/app/components/SportIcon.js